module.exports = __webpack_public_path__ + "img/allSpace.97a80b9c.jpg";